import { render, staticRenderFns } from "./VenuesSalesHitList.vue?vue&type=template&id=68ec96b7&"
import script from "./VenuesSalesHitList.vue?vue&type=script&lang=js&"
export * from "./VenuesSalesHitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports